import { Component, forwardRef, input, output } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { AbstractFormControlComponent } from '../abstract-form-control.component';

@Component({
  selector: 'shared-ui-currency',
  standalone: true,
  imports: [NgClass, FormsModule, ReactiveFormsModule],
  templateUrl: './currency.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CurrencyComponent),
      multi: true,
    },
  ],
})
export class CurrencyComponent extends AbstractFormControlComponent<number> {
  readonly label = input<string>('');
  readonly name = input.required<string>();
  readonly placeholder = input<string>('');
  readonly warningText = input('Fehlerhafte Eingabe');
  readonly isInvalid = input<boolean>(false);

  clicked = output<void>();

  private _value: number | null = null;
  displayValue = '';

  override writeValue(value: number | null): void {
    this._value = value;
    this.displayValue = this._value !== null ? this.format(this._value) : '';
  }

  onInput(event: Event): void {
    const input = (event.target as HTMLInputElement).value.replace(/[^0-9.,€-]/g, '');
    (event.target as HTMLInputElement).value = input; //pretends to reject non-numeric characters

    const numericValue = this.parse(input);

    this._value = numericValue;
    this.internalControl.setValue(numericValue, { emitEvent: false });
    this.displayValue = input;

    this.onChange(numericValue);
  }

  onBlur(): void {
    this.displayValue = this._value !== null ? this.format(this._value) : '';
    this.onTouched();
  }

  private format(value: number): string {
    return new Intl.NumberFormat('de-DE', {
      currency: 'EUR',
      maximumFractionDigits: 2,
    }).format(value);
  }

  private parse(value: string): number | null {
    const numberString = value.replaceAll('.', '').replace(',', '.');
    const num = parseFloat(numberString);
    return isNaN(num) ? null : num;
  }
}
